import React, { memo } from 'react';
import { Tab } from 'react-bootstrap';
import Masonry from 'react-masonry-component';
import Cards from './Cards';
const TabContent = ({ type_array, search_results, key }) => {
  const filterResultArray = (type) => {
    if (search_results?.some((r) => r.trending_type == type || r.type == type)) {
      return search_results?.filter((r) => r.trending_type == type || r.type == type);
    } else {
      return [];
    }
  };

  const TabPaneComponent = ({ eventKey }) => {
    let data = eventKey == 'all' ? search_results : filterResultArray(eventKey);
    return data?.length > 0 ? (
      <Tab.Pane eventKey={eventKey}>
        <Masonry className="ms-n4 ms-md-n5 mt-n4 mt-md-n5 me-0">
          {data?.map((d) => (
            <Cards type={d.trending_type || d.type} data={d} />
          ))}
        </Masonry>
      </Tab.Pane>
    ) : null;
  };
  console.log('get data', search_results);
  return (
    <Tab.Content className="px-3 px-md-0">
      {type_array?.map((_type) => (
        <TabPaneComponent eventKey={_type} />
      ))}
    </Tab.Content>
  );
};

export default memo(TabContent);
